import * as React from 'react';
import * as Redux from 'redux';

export interface IDropdownOption {
    id: string;
    display: string;
}

export interface IDropdownSelectProps {
    values: IDropdownOption[];
    selectedId?: string;
    display?: string;
    isMobile?: boolean;
    placeHolder?: string;
    onDropdownSelect: (id: string | number) => void;
    name?: string;
}

export interface IDropdownOptionProps {
    value: IDropdownOption;
    isMobile: boolean;
    onDropdownSelect: () => void;
    name?: string
}

var activeContext,
    activateDropDownClass = '';


export class DropdownOption extends React.Component<IDropdownOptionProps, any> {
    constructor(props) {
        super(props);
    }

    render() {
        const id = `${this.props.name}-${this.props.value.id}`;

        return (
            <option value={this.props.value.id}
                id={id}
                onClick={this.props.onDropdownSelect}>
                {this.props.value.display}
            </option>
        );
    }
};


export class DropdownSelect extends React.Component<IDropdownSelectProps, any> {
    static defaultProps = {
        placeHolder: '',
        display: '',
        isMobile: false,
        selectedId: ''
    }

    activateDropDown = (e) => {
        if (activateDropDownClass == '') {
            activateDropDownClass = 'active';
        } else if (activateDropDownClass == 'active') {
            activateDropDownClass = '';
        }

        this.forceUpdate();
    }

    // Close dropdown on outside click
    onBlur = () => {
        activateDropDownClass = '';
        this.forceUpdate();
    }

    renderOptions = (value, index) => {
        return <DropdownOption
                   name={`${this.props.name}-index`}
                   onDropdownSelect={this.onBlur}
                   key={index}
                   value={value}
                   isMobile={this.props.isMobile} />;
    }

    render() {
        return (
            <select onChange={(e) => this.props.onDropdownSelect((e.target as any).value)}
                value={this.props.selectedId}
                ref="fieldset">
                {this.props.values.map(this.renderOptions)}
            </select>
        )
    }
}